import ColumnSelectButton from 'components/ColumnSelectButton/ApplicationColumnButton';
import CustomTable from 'components/CustomTable';
import useApplicationTableData from 'hooks/useApplicationData';
import styled from 'styled-components/macro';
import CustomButton from 'components/CustomInput/Button';
import { useEffect, useState } from 'react';
import CustomPagination from 'components/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import TextHeader from 'components/CustomText/TextHeader';
import Filter from 'components/CustomTable/Filter';
import PageSize from 'components/CustomTable/PageSize';
import {
    APPLICATION_FETCH_WITH_CANCEL,
    APPLICATION_LIST_REFRESH,
    SET_APPLICATION,
    DOWNLOAD_APPLICATION,
} from 'store/key';
import { useLocation } from 'react-router';
import { setGlobalLoading } from 'store/global/reducer';
import { KEYS, getItem, setItem } from 'storage';
import usePrevious from 'hooks/usePrevious';
import { searchDocTypeEnum } from 'hooks/search/searchData';
import useSubscribe from 'hooks/useSubscribe';
import useQuery from 'hooks/useQuery';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SLayout = styled.div`
    padding: 10px;
`;

const SHeader = styled.div`
    font-weight: bold;
    display: flex;
    justify-content: space-between;
`;

const SPaginationLayout = styled.div`
    margin-top: 20px;
`;

const STableContent = styled.div`
    margin-top: 15px;
`;

const STitle = styled.div`
    margin-top: 10px;
`;

const SColumnSelectLayout = styled.div`
    margin-right: 30px;
`;

const SButtonLayout = styled.div`
    display: flex;
`;

const SActionLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
`;

const SFilterLayout = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 10px 0;
`;

const AllLayoutIndex = ({ name }) => {
    const location = useLocation();
    const folder = location.pathname.split('/applications/')?.[1];
    const history = useHistory();
    const queryPage = useQuery('page');
    const { rows, columns } = useApplicationTableData({ folder });
    const [expandCount, setExpandCount] = useState(0);
    const [filterKeyword, setFilterKeyword] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const isLoading = useSelector((state) => state.application.isLoading);
    const total = useSelector((state) => state.application.total);

    const prevFolder = usePrevious(folder);
    const appPage = getItem(KEYS.APP_PAGE);
    const appPageSize = getItem(KEYS.APP_PAGE_SIZE);
    let newPage = useSelector((state) => state.application.page);
    let newPageSize = useSelector((state) => state.application.pageSize ?? 10);
    const page = appPage ? Number(appPage) : newPage ?? 1;
    const pageSize = appPageSize ? Number(appPageSize) : newPageSize ?? 10;

    const sort = useSelector((state) => state.application.sort ?? 'updateDtm');
    const isDesc = useSelector((state) => state.application.isDesc ?? true);
    const dispatch = useDispatch();

    const refreshApplication = () => {
        dispatch({
            type: APPLICATION_LIST_REFRESH,
        });
    };

    useSubscribe('refresh', refreshApplication);

    const fetchApplication = ({ page = 1, pageSize = 10 }) => {
        if (appPage || appPageSize) {
            setItem(KEYS.APP_PAGE, '');
            setItem(KEYS.APP_PAGE_SIZE, '');
        }

        if (queryPage) {
            page = parseInt(queryPage);
            history.push(location.pathname);
        }

        dispatch({
            type: APPLICATION_FETCH_WITH_CANCEL,
            payload: {
                page,
                pageSize,
                folder: folder === 'all' ? '' : folder,
                sort,
                isDesc,
            },
        });
    };


    useEffect(() => {
        if (folder !== prevFolder) {
            if (!appPage && !appPageSize && (page !== 1 || pageSize !== 10)) {
                dispatch({
                    type: SET_APPLICATION,
                    payload: {
                        page: 1,
                        pageSize: 10,
                    },
                });
                fetchApplication({ page: 1, pageSize: 10 });
            } else {
                fetchApplication({ page, pageSize });
            }
        }
        // eslint-disable-next-line
    }, [folder, prevFolder]);

    const getFilterResultApplication = (rows = []) => {
        if (!filterKeyword) {
            return rows;
        }

        const filtered = rows.filter((row) => {
            let isFiltered = false;
            Object.entries(row).forEach(([key, value]) => {
                const currentColumn = columns.find((column) => column.field === key);
                const tempValue = currentColumn?.filterValue?.({ row }) ?? value;
                if (typeof tempValue === 'string' || typeof tempValue === 'number') {
                    if (tempValue.toString().toLowerCase().includes(filterKeyword.toLowerCase())) {
                        isFiltered = true;
                    }
                }
            });

            return isFiltered;
        });

        return filtered;
    };

    const handleDownload = () => {
        setGlobalLoading(true);
        const requestData = selectedRows.map((item) => {
            let data = {
                id: item.id,
                docType: searchDocTypeEnum.INIT_APPLICATION,
            };
            return data;
        });

        dispatch({
            type: DOWNLOAD_APPLICATION,
            payload: {
                data: requestData,
                callback: () => setGlobalLoading(false),
            },
        });
    };

    return (
        <SLayout>
            <SHeader>
                <STitle>
                    <TextHeader>Application List</TextHeader>
                </STitle>
            </SHeader>
            <SActionLayout>
                <SButtonLayout>
                    <SColumnSelectLayout>
                        <ColumnSelectButton />
                    </SColumnSelectLayout>
                    <CustomButton showMargin onClick={() => setExpandCount(-1 - Math.random())}>
                        Collapse All
                    </CustomButton>
                    <CustomButton showMargin onClick={() => setExpandCount(1 + Math.random())}>
                        Expand All
                    </CustomButton>
                    <CustomButton
                        showToolTipInDisabledOnly
                        tooltip={'please select application would like to download'}
                        showMargin
                        disabled={isLoading || !selectedRows.length}
                        onClick={handleDownload}
                    >
                        Download Application
                    </CustomButton>
                    <CustomButton onClick={() => refreshApplication()}>Refresh</CustomButton>
                </SButtonLayout>
            </SActionLayout>

            <SFilterLayout>
                <Filter
                    onChange={(value) => {
                        setFilterKeyword(value);
                    }}
                    value={filterKeyword}
                />
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                    <PageSize
                        label="Page Size"
                        value={pageSize}
                        onChange={(value) => {
                            fetchApplication({ pageSize: value });
                        }}
                    />
                </div>
            </SFilterLayout>

            <STableContent>
                <CustomTable
                    disabledHeaderCheckbox={true}
                    disabledItemCheckbox={selectedRows.length > 0}
                    defaultSortKey={sort}
                    isDesc={isDesc}
                    isSortable
                    isCheckboxEnable
                    onRowSelected={(data) => {
                        setSelectedRows(data);
                    }}
                    showAlternativeBackground
                    columns={columns}
                    rows={getFilterResultApplication(rows)}
                    isExpandRow
                    allowResize
                    isExpandAll={expandCount}
                    loading={isLoading}
                    skipMaxHeight={false}
                />
            </STableContent>

            {page && (
                <SPaginationLayout>
                    <CustomPagination
                        page={page}
                        pageSize={pageSize}
                        total={total}
                        isLoading={isLoading}
                        onPageChange={(page) => fetchApplication({ page, pageSize })}
                    />
                </SPaginationLayout>
            )}
        </SLayout>
    );
};

export default AllLayoutIndex;
